import { animate, style, transition, trigger } from '@angular/animations';
import { Component, HostBinding, Input, ViewChild } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { NgScrollbar } from 'ngx-scrollbar';
import { DashboardService } from '../dashboard.service';

@Component({
    selector: 'ms-dashboard-sidebar',
    templateUrl: './dashboard-sidebar.component.html',
    styleUrls: ['./dashboard-sidebar.component.scss'],
    animations: [
        trigger('slide', [
            transition(':enter', [
                style({ transform: 'translateX(-100%)' }),
                animate('70ms', style({ transform: 'translateX(0%)' })),
            ]),
            transition(':leave', [animate('70ms', style({ transform: 'translateX(-100%)' }))]),
        ]),
    ],
    standalone: false
})
export class DashboardSidebarComponent {
  @Input() color: 'purple' | 'yellow' = 'purple';

  @ViewChild('sidebarScrollbar')
  public get sidebarScrollbarRef(): NgScrollbar {
    return this._dashboardService.sidebarScrollbarRef;
  }

  public set sidebarScrollbarRef(value: NgScrollbar) {
    this._dashboardService.sidebarScrollbarRef = value;
  }

  @ViewChild('overlayScrollbar')
  public get overlayScrollbarRef(): NgScrollbar {
    return this._dashboardService.overlayScrollbarRef;
  }

  public set overlayScrollbarRef(value: NgScrollbar) {
    this._dashboardService.overlayScrollbarRef = value;
  }

  public get mode(): 'shrink' | 'normal' {
    return this._dashboardService.sidebarMode();
  }

  get isShrink() {
    return this._dashboardService.isShrink;
  }

  @HostBinding('class.overlay-mode')
  get isOverlayOpen() {
    return this._dashboardService.isOverlayOpen;
  }

  constructor(private readonly _dashboardService: DashboardService, private _router: Router) {
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.closeOverlay();
      }
    });
  }

  onMouseEnterSidebar() {
    this._dashboardService.isSidebarHover = true;
  }

  onMouseExitSidebar() {
    this._dashboardService.isSidebarHover = false;
  }

  closeOverlay() {
    this._dashboardService.closeOverlay();
  }
}
